module.exports = __webpack_public_path__ + "static/img/2277_phase_function_Paper_Points.4d516ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2277_phase_function_Paper_Points.png
// module id = Vx8C
// module chunks = 0